import React from "react";
import { CustomButton } from "../atoms/CustomButton";

const FeatureCtaCard: React.FC<{
  icon: React.ReactNode;
  title: string;
  body?: string;
  ctaLabel: string;
  ctaIcon?: React.ComponentProps<typeof CustomButton>["icon"];
  onCta: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
}> = ({
  icon,
  title,
  body,
  ctaLabel,
  ctaIcon,
  onCta,
  secondaryLabel,
  onSecondary,
}) => (
  <div className="bg-blue-50/60 border border-blue-100 rounded-xl p-5 sm:p-6 text-center">
    <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-white text-blue-600 border border-blue-100 mb-3">
      {icon}
    </div>
    <h3 className="text-base font-bold text-gray-900">{title}</h3>
    {body && (
      <p className="text-sm text-gray-600 mt-1.5 max-w-md mx-auto">{body}</p>
    )}
    <div className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
      <CustomButton
        variant="primary"
        icon={ctaIcon}
        title={ctaLabel}
        onClick={onCta}
        className="w-full sm:w-auto"
      />
      {secondaryLabel && onSecondary && (
        <button
          type="button"
          onClick={onSecondary}
          className="text-sm font-medium text-blue-600 hover:text-blue-700 hover:underline text-center py-2 sm:py-0"
        >
          {secondaryLabel}
        </button>
      )}
    </div>
  </div>
);

export default FeatureCtaCard;
